import { z } from 'zod';

export const addAdminSchema = z.object({
  email: z
    .string({
      required_error: 'Administratoriaus El. paštas privalomas!',
    })
    .email('Netinkamas El. pašto formatas!'),
  password: z
    .string({
      required_error: 'Administratoriaus slaptažodis privalomas!',
    })
    .min(6, 'Slaptažodi ilgis turi būti bent 6 simbolių!')
    .max(25, 'Slaptažodi ilgis turi būti nedaugiau kaip 25 simboliai!'),
});

export type addAdminInputs = z.infer<typeof addAdminSchema>;
